import { PieChart } from '@/common/dashboard/charts/PieChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const McoDispBreakdownPieChart = ({
  selectedPeriod,
  selectedPbms,
  selectedCtrts,
}) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!selectedPeriod?.id) {
      return;
    }

    const pbmIds = selectedPbms.map((pbm) => pbm.id);
    const ctrtIds = selectedCtrts.map((ctrt) => ctrt.id);
    const reqParam = {
      periodId: selectedPeriod.id,
      pbmIds,
      ctrtIds,
    };

    rsrc
      .data('sc', 'MCO_DISP_BREAKDOWN_CHART_DATA_PLUGIN', reqParam)
      .then((data) => {
        setData(data);
      });
  }, [selectedPeriod, selectedPbms, selectedCtrts]);

  return <PieChart data={data} />;
};
